import { connect } from 'react-redux';

// import {
//   GET_LIST_ROOM_OF_PLACE,
//   GET_PLACE_PRICE_TYPES,
// } from 'store/place/actionTypes';
import {
  CLEAR_PLACE_PROMOTION_DETAIL,
  CREATE_PLACE_PROMOTION,
  EDIT_PROMOTION,
  GET_PLACE_PROMOTION_DETAIL,
} from 'store/promotion/actionTypes';

import CreateEnterprisePromotion from './CreateEnterprisePromotion';

const mapStateToProps = (state) => ({
  isLoadingGetPlacePromotionDetail: state.Promotion.isLoadingGetPlacePromotionDetail,
  isLoadingCreatePlacePromotion:
    state.Promotion.isLoadingCreatePlacePromotion,

  placePromotionDetail: state.Promotion.placePromotionDetail,
  // roomOfPlaceList: state.Place.roomOfPlaceList,
  // placePriceTypes: state.Place.placePriceTypes,
});

const mapDispatchToProps = (dispatch) => ({
  // actionGetListRoomsOfPlace: (payload) =>
  //   dispatch({
  //     type: GET_LIST_ROOM_OF_PLACE,
  //     payload,
  //   }),

  // actionGetPlacePriceTypes: (payload) => {
  //   dispatch({
  //     type: GET_PLACE_PRICE_TYPES,
  //     payload,
  //   });
  // },

  actionGetPlacePromotionDetail: (payload) => {
    dispatch({
      type: GET_PLACE_PROMOTION_DETAIL,
      payload,
    });
  },

  actionEditPromotion: (payload) => {
    dispatch({
      type: EDIT_PROMOTION,
      payload,
    });
  },

  actionClearDataPlacePromotionDetail: (payload) => {
    dispatch({
      type: CLEAR_PLACE_PROMOTION_DETAIL,
      payload,
    });
  },

  actionCreatePlacePromotion: (payload) => {
    dispatch({
      type: CREATE_PLACE_PROMOTION,
      payload,
    });
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CreateEnterprisePromotion);
